import type { ReactNode } from 'react';
import React from 'react';

type PriceProps = {
  children?: ReactNode;
  value?: string;
};

function Price({ children, value }: PriceProps) {
  return (
    <h4 className="Offer-price" data-testid="offer-price">
      {children || value}
    </h4>
  );
}

Price.displayName = 'Price';

export { Price };
